module.exports = __webpack_public_path__ + "media/pricing/Toolbox_Talk-153f643c.pdf";